import {
  getEmployeesForRoleAssignment,
  getRolesForAssignment,
  assignRoleEmployee as assignRoleEmployeeService,
} from "services/company/role/employeeRoleService";
import {
  getEmployeeRolesStart,
  getEmployeeRolesSuccess,
  getEmployeeRolesFailure,
  getRolesForAssignmentStart,
  getRolesForAssignmentSuccess,
  getRolesForAssignmentFailure,
  assignRoleEmployeeStart,
  assignRoleEmployeeSuccess,
  assignRoleEmployeeFailure,
} from "./employeeRoleSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch employees (for the roles view)
export const fetchEmployeeRoles = () => async (dispatch) => {
  try {
    dispatch(getEmployeeRolesStart());
    const response = await getEmployeesForRoleAssignment();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getEmployeeRolesSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch employees";
      dispatch(getEmployeeRolesFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch employees";
    dispatch(getEmployeeRolesFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Fetch available roles for dropdown
export const fetchAvailableRoles = () => async (dispatch) => {
  try {
    dispatch(getRolesForAssignmentStart());
    const response = await getRolesForAssignment();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getRolesForAssignmentSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch roles";
      dispatch(getRolesForAssignmentFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch roles";
    dispatch(getRolesForAssignmentFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Assign role to employee
export const assignRoleToEmployee = (payload) => async (dispatch) => {
  try {
    dispatch(assignRoleEmployeeStart());
    const response = await assignRoleEmployeeService(payload);

    if (response?.meta?.status === true || response?.meta?.code === 200) {
      dispatch(assignRoleEmployeeSuccess());
      showSuccessToast(response?.meta?.message || "Role assigned successfully!");
      // Re-fetch the employee roles to update the list
      dispatch(fetchEmployeeRoles());
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to assign role";
      dispatch(assignRoleEmployeeFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to assign role";
    dispatch(assignRoleEmployeeFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
